<template>
  <div class="vendor vendor-simple col-sm-12">
    <div class="vendor-title pointer" @click="displayMore = !displayMore">
      <strong>
        <span class="tc-title" v-html="vendor.label"></span>
        <span v-if="displayMore" class="chevron glyphicon glyphicon-chevron-up" aria-hidden="true"></span>
        <span v-else class="chevron glyphicon glyphicon-chevron-down" aria-hidden="true"></span>
      </strong>
      <span @click.stop>
        <pc-checkbox-button
          v-if="settings.consentButtonStyle === 'button'"
          :aria-label="vendor.label"
          v-model="vendor.consent"
          :settings="settings"
          :label-on="settings.labelBtOn"
          :label-off="settings.labelBtOff"
          @input="emitConsentChanged"
        ></pc-checkbox-button>
        <pc-checkbox-native
          v-else-if="settings.consentButtonStyle === 'checkbox'"
          v-model="vendor.consent"
          :settings="settings"
          @input="emitConsentChanged"
        ></pc-checkbox-native>
        <pc-leg-switch
          v-else
          class="pull-right"
          v-model="vendor.consent"
          :settings="settings"
          :label-on="settings.labelBtOn"
          :label-off="settings.labelBtOff"
          @input="emitConsentChanged"
        ></pc-leg-switch>
      </span>
    </div>
    <div class="vendor-details" v-if="displayMore">
      <p v-if="vendor.description" v-html="vendor.description"></p>
      <p v-if="vendor.domains && vendor.domains.length">{{ vendor.domains.join(', ') }}</p>
      <strong class="policy-title">{{ $t('privacyPolicy') }}:</strong>
      <a :href="vendor.policyUrl">{{ vendor.policyUrl }}</a>
      <div v-if="vendor.categories.length > 0">
        <strong>{{ $t('categories') }}:</strong>
        <ul>
          <li
            v-for="category in vendor.categories"
            :key="`v${vendor.id}${category}`"
            v-html="categoriesById[category] ? categoriesById[category].label : ''"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import PcLegSwitch from '@/components/forms/pc-leg-switch';
import PcCheckboxButton from '@/components/forms/pc-checkbox-button';
import PcCheckboxNative from '@/components/forms/pc-checkbox-native';
import { i18nMixin } from 'shared/i18n/i18n-mixin';
import { eventEmitterMixin } from '@/common/messaging/event-emitter-mixin';
import { stripHtml } from '@/common/filters/strip-html';

export default {
  components: {
    PcLegSwitch,
    PcCheckboxButton,
    PcCheckboxNative,
  },
  mixins: [i18nMixin, eventEmitterMixin],
  props: {
    vendor: {
      type: Object,
      required: true,
    },
    categoriesById: {
      type: Object,
      default: () => ({}),
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      displayMore: false,
    };
  },
  methods: {
    stripHtml,
  },
};
</script>
